import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Shop.module.sass";
import Profile from "./Profile";
import Card from "../../components/Card";
import Dropdown from "../../components/Dropdown";

// screen
import NameAndDescription from "./NameAndDescription";
import ApiKey from "./ApiKey";

// data
import { getCurrentPartnerInfo } from "../../services/partner.service";

// const navigation = ["Informations", "Forfait", "Facturation"];
const navigation = ["Informations", "Clé API"];

const AccountPartner = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPartnerData = async () => {
      try {
        const data = await getCurrentPartnerInfo();
        if (data) {
          setPartner(data);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données du partenaire:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPartnerData();
  }, []);

  return (
    <>
      <div className={styles.shop}>
        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>
        <Card className={styles.card}>
          <Profile partner={partner} />
          <div className={styles.control}>
            <div className={cn(styles.nav, styles.desktopNav)}>
              {navigation.map((x, index) => (
                <button
                  className={cn(styles.link, {
                    [styles.active]: index === activeIndex,
                  })}
                  onClick={() => setActiveIndex(index)}
                  key={index}
                >
                  {x}
                </button>
              ))}
            </div>
            <div className={styles.mobileNav}>
              <div style={{ position: 'relative' }}>
                <Dropdown
                  className={styles.dropdown}
                  value={navigation[activeIndex]}
                  setValue={(value) => {
                    const index = navigation.findIndex(x => x === value);
                    if (index !== -1) setActiveIndex(index);
                  }}
                  options={navigation}
                />
              </div>
            </div>
          </div>
        </Card>
        <div className={styles.wrap}>
          {activeIndex === 0 && (
            <NameAndDescription partner={partner}/>
          )}
          {activeIndex === 1 && (
            <ApiKey partner={partner}/>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountPartner;
